import React from 'react'
import { Table } from 'antd'
import { IMultiLocationInventory } from '@getgreenline/homi-shared'
import { CreatePOReceipt } from './CreatePOReceipt'
import { observer } from 'mobx-react-lite'

interface Props {
  createPOReceipt: CreatePOReceipt
}

interface TableProduct {
  parentName: string
  name: string
  sku: string
}

interface LowStockTableSource {
  key: string
  restock: number | null
  quantity: number
  toorder: number
  product: {
    id: string
    name: string
    sku: string | null
    parentName: string | null
  }
}

const columns = [
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'name',
    render: (product: TableProduct) => (
      <div>
        <div className='text-muted'>SKU: {product.sku}</div>
        <div>{`${product.parentName !== null ? product.parentName + ' - ' : ''} ${
          product.name
        }`}</div>
      </div>
    ),
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    className: 'text-right',
  },
  {
    title: `Restock`,
    dataIndex: 'restock',
    key: 'restock',
    className: 'text-right',
  },
  {
    title: `To order`,
    dataIndex: 'toorder',
    key: 'toorder',
    className: 'text-right',
  },
]

export const LowStockTable = observer((props: Props) => {
  const createPOReceipt = props.createPOReceipt
  const rowSelection = {
    selectedRowKeys: createPOReceipt.selectedLowStockProductIds,
    onChange: (selectedRowKeys: string[] | number[], selectedRows: LowStockTableSource[]) => {
      const selectedLowStockProductIds = selectedRows.map((row) => row.product.id)
      createPOReceipt.setSelectedLowStockProductIds(selectedLowStockProductIds)
    },
  }

  const dataSource = createPOReceipt.lowStockProducts.map(
    (multiLocationInventory: IMultiLocationInventory) => {
      return {
        key: multiLocationInventory.product.id,
        restock: multiLocationInventory.inventories[0].restockQuantity,
        quantity: multiLocationInventory.inventories[0].quantity,
        toorder: multiLocationInventory.inventories[0].restockQuantity
          ? multiLocationInventory.inventories[0].restockQuantity -
            multiLocationInventory.inventories[0].quantity
          : 0,
        product: {
          id: multiLocationInventory.product.id,
          name: multiLocationInventory.product.name,
          sku: multiLocationInventory.product.sku,
          parentName: multiLocationInventory.product.parentProductName,
        },
      }
    },
  )

  return (
    <Table
      loading={createPOReceipt.loadingLowStockProducts}
      pagination={{
        defaultCurrent: 1,
        total: createPOReceipt.lowStockProducts.length || 1,
      }}
      rowSelection={rowSelection}
      dataSource={dataSource}
      columns={columns}
    />
  )
})
